var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"300px"}},[_c('canvas',{attrs:{"width":"400","height":"100","id":_vm.random_id}})])}
var staticRenderFns = []

export { render, staticRenderFns }